<template>

  <div id="app">
    <router-view class="router"></router-view>
  </div>
</template>

<script>
  import { getUserData,USER_INFO,upUserData} from '@/api/user'
  export default {
    name: 'App',
    data() {
      return {
        user:{}
      }
    },
    created() {
      this.user = USER_INFO({
        avatar:getUserData().avatar,
        name:getUserData().name,
        _id:getUserData()._id,
      });
      this.user  = upUserData();
    },
    methods: {
//      upInfo(){
//        upUserInfo().then(res=>{
//          if(res.rc === 0 && res.user){
//            this.user =  USER_INFO({
//              point:res.user.point || 0,
//              isVip:res.user.biz.is_xy_vip || false,
//              vipExpire: res.user.biz.xy_vip_expire,
//              username:res.user.username || '',
//              _id:res.user._id || '',
//              avatar:res.user.avatar_url || '',
//              mvp:res.user.mvp_count || '',
//              liked:res.user.be_liked_count || '',
//              translation:res.user.translation_count || '',
//            })
//          }
//        })
//      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/App.vue